/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { toastError } from '@/components/toast'
import { getStringAsync } from '@/blackbolt/i18n/bundle.generated'

/** Failure toast for like / unlike / follow / unfollow. */
export function toastRelationshipFailure(): void {
    toastError(getStringAsync('dmusic_feed_card_action_failure'))
}

/** Failure toast for the "Not for me" dismiss verb. */
export function toastDismissFailure(): void {
    toastError(getStringAsync('dmusic_feed_card_action_failure'))
}
